// action types
export const VIDEO = "[Video]";
export const SET_VIDEO = "SET_VIDEO";
export const GET_VIDEO = "GET_VIDEO";

export const setVideo = payload => ({
  type: `${SET_VIDEO}`,
  payload
});

export const getVideo = () => ({
  type: `${GET_VIDEO}`
});



// WEBPACK FOOTER //
// ./src/redux/actions/videoActions.js